// extracted by mini-css-extract-plugin
module.exports = {"list":"HowItWorksList_list__xqyRw","item":"HowItWorksList_item__sTh8k","title":"HowItWorksList_title__BU2uB","description":"HowItWorksList_description__PX13a"};